import { render, staticRenderFns } from "./WayPointOption.vue?vue&type=template&id=b06f974e&scoped=true&"
import script from "./WayPointOption.vue?vue&type=script&lang=ts&"
export * from "./WayPointOption.vue?vue&type=script&lang=ts&"
import style0 from "./WayPointOption.vue?vue&type=style&index=0&id=b06f974e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06f974e",
  null
  
)

export default component.exports